<template>
  <ContentWrap>
    <el-collapse v-model="activeNames">
      <el-collapse-item name="basicInfo">
        <template #title>
          <span class="text-base font-bold">基本信息</span>
        </template>
        <el-descriptions :column="4">
          <el-descriptions-item label="产品名称">{{ product.name }}</el-descriptions-item>
          <el-descriptions-item label="编号">{{ product.no }}</el-descriptions-item>
          <el-descriptions-item label="产品类型">{{ product.categoryName }}</el-descriptions-item>
          <el-descriptions-item label="是否上下架">
            <dict-tag :type="DICT_TYPE.CRM_PRODUCT_STATUS" :value="product.status" />
          </el-descriptions-item>
          <el-descriptions-item label="单位">
            <dict-tag :type="DICT_TYPE.CRM_PRODUCT_UNIT" :value="product.unit" />
          </el-descriptions-item>
          <el-descriptions-item label="价格">
            {{ erpPriceInputFormatter(product.price) }} 元
          </el-descriptions-item>
          <el-descriptions-item label="演示站名称">{{ product.demoSiteName }}</el-descriptions-item>
          <el-descriptions-item label="演示网址">{{ product.demoUrl }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <dict-tag :type="DICT_TYPE.CRM_PRODUCT_DEMO_STATUS" :value="product.demoStatus ?? ''" />
          </el-descriptions-item>
          <el-descriptions-item label="端口">{{ product.port }}</el-descriptions-item>
          <el-descriptions-item label="行业">
            <dict-tag :type="DICT_TYPE.CRM_PRODUCT_INDUSTRY" :value="product.industry ?? ''" />
          </el-descriptions-item>
          <el-descriptions-item label="应用场景">
            <dict-tag
              :type="DICT_TYPE.CRM_PRODUCT_APPLICATION_SCENE"
              :value="product.applicationScene ?? ''"
            />
          </el-descriptions-item>
          <el-descriptions-item label="开发语言">{{ product.devLanguage }}</el-descriptions-item>
          <el-descriptions-item label="数据库">{{ product.databaseName }}</el-descriptions-item>
          <el-descriptions-item label="二维码">
            <el-image
              v-if="product.qrcode"
              :src="product.qrcode"
              :preview-src-list="[product.qrcode]"
              preview-teleported
              fit="contain"
              style="width: 80px; height: 80px"
            />
          </el-descriptions-item>
          <el-descriptions-item label="产品描述">{{ product.description }}</el-descriptions-item>
          <el-descriptions-item label="报价" :span="4">{{
            product.quotation
          }}</el-descriptions-item>
          <el-descriptions-item label="产品介绍" :span="4">
            {{ product.introduction }}
          </el-descriptions-item>
          <el-descriptions-item label="演示网址与账号密码" :span="4">
            {{ product.demoAccount }}
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
    </el-collapse>
  </ContentWrap>
</template>
<script setup lang="ts">
import { DICT_TYPE } from '@/utils/dict'
import * as ProductApi from '@/api/crm/product'
import { erpPriceInputFormatter } from '@/utils'

const { product } = defineProps<{
  product: ProductApi.ProductVO
}>()

// 展示的折叠面板
const activeNames = ref(['basicInfo'])
</script>
